var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5339 2.77994C21.1554 2.91493 16.428 3.40625 13.5095 5.19271C13.3082 5.31597 13.194 5.53515 13.194 5.76432V21.5573C13.194 22.0586 13.7422 22.3754 14.2044 22.1428C17.207 20.6315 21.5495 20.2192 23.6966 20.1063C24.4297 20.0677 24.9996 19.48 24.9996 18.7756V4.11241C25 3.34375 24.3333 2.73481 23.5339 2.77994ZM11.49 5.19271C8.57205 3.40625 3.84462 2.91536 1.46615 2.77994C0.666667 2.73481 0 3.34375 0 4.11241V18.776C0 19.4809 0.569878 20.0686 1.30295 20.1068C3.45095 20.2196 7.79557 20.6324 10.7982 22.1445C11.2591 22.3767 11.8056 22.0603 11.8056 21.5603V5.75651C11.8056 5.52691 11.6918 5.3164 11.49 5.19271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookOpen);
export default __webpack_public_path__ + "static/media/icon-book-open.2ab334108fd08216a2eb3b2675e3950a.svg";
export { ForwardRef as ReactComponent };